import React from 'react';
import {
  makeStyles,
  mergeClasses,
  shorthands,
  tokens,
} from '@fluentui/react-components';

const useBannerDescriptionStyles = makeStyles({
  root: {
    position: 'relative',
    ...shorthands.gridArea('description'),
    paddingRight: tokens.spacingHorizontalXL,
    paddingBottom: tokens.spacingVerticalXL,

    // use negative margin to make description align with title while still supporting empty description scenario
    marginTop: `calc(${tokens.spacingVerticalXS} - ${tokens.spacingVerticalXL})`,
  },
});

export const BannerDescription: React.FC<{ children: React.ReactNode }> = React.memo(({ children }) => {
  const classes = useBannerDescriptionStyles();

  return (
    <div className={mergeClasses(classes.root, 'banner-description')}>
      {children}
    </div>
  );
});
